import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PAGINGATION_DEFAULT } from '@const/pagination'
import {
  fetchRevenueListByMonth,
  fetchRevenueListByLiver,
  fetchDepositList,
  fetchHistory,
  fetchGmbChargeList
} from './asyncAction'

const initList = {
  data: [],
  ...PAGINGATION_DEFAULT
}

const initialState: TChargeManagementDetail.State = {
  listByMonth: initList,
  listByLiver: initList,
  listGMBCharge: initList,
  isFetchingList: false,
  isGMBChargeLoading: false,
  gmbListfilter: {
    from: '',
    to: '',
    keyword: ''
  },
  listBy: 'month',
  listDepositBy: 'store',
  showGiftCardPopup: false,
  selectedLiver: {},
  filter: {
    from: '',
    to: '',
    isAprroved: null
  },
  depositFilter: {
    from: '',
    to: '',
    paymentType: '',
    orderField: 'lastDepositTime',
    orderDirection: 'desc'
  },
  depositList: {
    data: [],
    ...PAGINGATION_DEFAULT
  },
  depositHistoryList: {
    data: [],
    ...PAGINGATION_DEFAULT
  },
  isUploading: false,
  isDownloading: false,
  searchTime: new Date().getTime(),
  selectedStoreDeposit: {},
  isAddingDeposit: false
}

const chargeManagementSlice = createSlice({
  initialState,
  name: 'chargeManagementSlice',
  reducers: {
    setIsListBy (state, action: PayloadAction<TChargeManagementDetail.State['listBy']>) {
      state.listBy = action.payload
    },
    // setFilterByMonth (state, action: PayloadAction<{ field: Partial<keyof TChargeManagementDetail.State['filterByMonth']>, value: string }>) {
    //   const { field, value } = action.payload
    //   state.filterByMonth[field] = value
    // },
    // setFilterByIsConfirmed (state, action: PayloadAction<boolean | null>) {
    //   state.filterByIsConfirmed = action.payload
    // }
    setFilter (state, action: PayloadAction<{ field: Partial<keyof TChargeManagementDetail.State['filter']>, value: any }>) {
      const { field, value } = action.payload
      // @ts-ignore
      state.filter[field] = value
    },
    setDepositFilter (state, action: PayloadAction<{ field: Partial<keyof TChargeManagementDetail.State['depositFilter']>, value: any }>) {
      const { field, value } = action.payload
      state.depositFilter[field] = value
    },
    setDepositListBy (state, action) {
      state.listDepositBy = action.payload
    },
    setSearchDeposit (state) {
      state.searchTime = new Date().getTime()
    },
    setSelectedDepositStore (state, action) {
      state.selectedStoreDeposit = action.payload
    },
    toggleAddDepositModal (state) {
      state.isAddingDeposit = !state.isAddingDeposit
    },
    setUpload (state, action) {
      state.isUploading = action.payload
    },
    setDownload (state, action) {
      state.isDownloading = action.payload
    },
    toogleGiftCardPopup (state) {
      state.showGiftCardPopup = !state.showGiftCardPopup
    },
    selectLiver (state, action) {
      state.selectedLiver = action.payload
    },
    setDepositOrderield (state, action) {
      state.depositFilter.orderField = action.payload
    },
    setDepositOrderDirection (state, action) {
      state.depositFilter.orderDirection = action.payload
    },
    changeSearchFromDate (state, action) {
      state.gmbListfilter.from = action.payload
    },
    changeSearchToDate (state, action) {
      state.gmbListfilter.from = action.payload
    },
    changeSearchKeyWord (state, action) {
      state.gmbListfilter.keyword = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchRevenueListByMonth.pending, state => {
        state.isFetchingList = true
      })
      .addCase(fetchRevenueListByMonth.fulfilled, (state, action) => {
        if (!action.payload?.data) return
        state.listByMonth = action.payload
        state.isFetchingList = false
      })
    builder
      .addCase(fetchRevenueListByLiver.pending, state => {
        state.isFetchingList = true
      })
      .addCase(fetchRevenueListByLiver.fulfilled, (state, action) => {
        if (!action.payload?.data) return
        state.listByLiver = action.payload
        state.isFetchingList = false
      })
      .addCase(fetchDepositList.fulfilled, (state, action) => {
        state.depositList = action.payload
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.depositHistoryList = action.payload
      })

    builder
      .addCase(fetchGmbChargeList.pending, state => {
        state.isGMBChargeLoading = true
      })
      .addCase(fetchGmbChargeList.fulfilled, (state, action) => {
        if (!action.payload?.data) return
        state.listGMBCharge = action.payload
        state.isGMBChargeLoading = false
      })
  }
})

export * from './asyncAction'

export const chargeManagementReducer = chargeManagementSlice.reducer

export const {
  setIsListBy,
  setFilter,
  setDepositFilter,
  setDepositListBy,
  setSearchDeposit,
  setSelectedDepositStore,
  toggleAddDepositModal,
  setUpload,
  setDownload,
  toogleGiftCardPopup,
  selectLiver,
  setDepositOrderield,
  setDepositOrderDirection,
  changeSearchFromDate,
  changeSearchToDate,
  changeSearchKeyWord
} = chargeManagementSlice.actions
